import React from 'react';
import PropTypes from 'prop-types';
import { Image, Grid, Modal, Divider } from 'semantic-ui-react';
import NewCampaignForm from '../new-campaign-form';
import HelpLink from '../help-link';
import ThemeSelector from '../../themes/theme-selector';
import NewCampaignSteps from './new-campaign-steps';
import CampaignTypeButtons from './campaign-type-buttons';

const noPadding = {
  padding: '0',
};

const imageStyle = {
  display: 'block',
  margin: '170px auto 0px auto',
};

const leftBlockStyle = {
  ...noPadding,
  backgroundColor: '#f7fafa',
  borderRadius: '4px',
};

const modalContentStyle = {
  ...noPadding,
};

const rightBlockStyle = {
  padding: '50px',
};

const linkWrapperStyle = {
  width: '100%',
  textAlign: 'center',
  marginTop: 40,
};

class NewAddCampaignModal extends React.Component {
  constructor(props) {
    super(props);
    const { stepIndex, campaignType } = props;
    this.state = { stepIndex, campaignType };
  }

  onTypeSelected = campaignType => {
    this.setState({
      campaignType,
      stepIndex: 2,
    });
  }

  render = () => {
    const {
      title,
      onClose,
      onAddCampaignSubmit,
      allowCampaignTypeChange,
    } = this.props;
    const {
      stepIndex,
      campaignType,
    } = this.state;
    const { disableHelpLinks } = ThemeSelector.theme();

    return (
      <Modal
        open
        closeOnEscape
        closeOnDimmerClick
        onClose={onClose}
      >
        <Modal.Content >
          <Grid>
            {allowCampaignTypeChange && <Grid.Row style={noPadding}>
              <NewCampaignSteps
                stepIndex={stepIndex}
                onStepClick={i => this.setState({ stepIndex: i })}
              />
              <Divider hidden />
            </Grid.Row>}
            {(stepIndex === 2 || !allowCampaignTypeChange) &&
              <Grid.Row style={modalContentStyle}>
                <Grid.Column width={8} style={leftBlockStyle}>
                  <Image src="/images/add-campaign.svg" style={imageStyle} />
                  <div style={linkWrapperStyle}>
                    {!disableHelpLinks &&
                      <HelpLink url="https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign" />
                    }
                  </div>
                </Grid.Column>
                <Grid.Column width={8} style={rightBlockStyle}>
                  <h3>{title}</h3>
                  <Divider hidden />
                  <NewCampaignForm
                    onBackClick={() => this.setState({
                      stepIndex: 1,
                    })}
                    campaignType={campaignType}
                    onFormSubmit={onAddCampaignSubmit}
                  />
                  <Divider hidden />
                </Grid.Column>
              </Grid.Row>
            }
            {(stepIndex === 1 && allowCampaignTypeChange) &&
              <Grid.Row style={modalContentStyle}>
                <Grid.Column width={16}>
                  <CampaignTypeButtons
                    onTypeSelected={this.onTypeSelected}
                  />
                </Grid.Column>
              </Grid.Row>
            }
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

NewAddCampaignModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAddCampaignSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  campaignType: PropTypes.string,
  stepIndex: PropTypes.number,
  allowCampaignTypeChange: PropTypes.bool.isRequired,
};

NewAddCampaignModal.defaultProps = {
  title: 'Add a campaign',
  stepIndex: 1,
  buttonLabel: 'Save',
  campaignType: null,
};

export default NewAddCampaignModal;



/** WEBPACK FOOTER **
 ** ./src/components/new-add-campaign-modal/index.js
 **/